const items = [
  { icon: 'ri-flashlight-fill', title: '高速下载', desc: '直链加速通道，热门软件下载稳定不中断' },
  { icon: 'ri-database-2-fill', title: '资源丰富', desc: '覆盖 Windows、安卓、Mac、iOS 全平台工具' },
  { icon: 'ri-shield-check-fill', title: '安全无毒', desc: '人工审核收录，安装包清晰标注版本与大小' },
  { icon: 'ri-refresh-line', title: '持续更新', desc: '紧跟软件版本迭代，第一时间同步新版本' },
];

export default function Advantages() {
  return (
    <section className="border-y border-background-200 bg-background-50">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 gap-4 px-4 py-8 sm:grid-cols-2 md:px-6 lg:grid-cols-4">
        {items.map((item) => (
          <div key={item.title} className="flex items-start gap-3">
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className={`${item.icon} text-xl`}></i>
            </span>
            <div>
              <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-500">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}